export const GsCtaQuestionFrag = `
fragment GsCtaQuestionFrag on GsCtaQuestion { 
  question {
    value
  }
  answers {
    targetItems {
      id
      name
      displayName
      ... on GsCtaAnswer {
        text {
          value
        }
        nextQuestion {
          id: targetId
        }
        service {
          id: targetId
        }
      }
    }
  }
}`;
